import {
  dateFormat,
  dateTimeFormatEU,
  timeFormatEU,
} from '@lib/enums/dateTime';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';

// A message bubble shows only the time (HH:mm) when it was posted today, so a
// busy conversation stays compact. For any earlier day it also shows the date,
// so older messages aren't mistaken for ones sent today.
export default function formatMessageTime(
  createdAt?: string | null,
): string | null {
  if (!createdAt) return null;
  const isToday =
    getFormattedDate(createdAt, dateFormat) ===
    getFormattedDate(new Date(), dateFormat);
  return getFormattedDate(createdAt, isToday ? timeFormatEU : dateTimeFormatEU);
}
